import React from "react";

export default function LetterX({
  width = "40",
  height = "40",
  stroke = "#606F7B",
  fill = "#F8FAFC"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 40"
    >
      <g id="Canvas" fill="none">
        <g id="LetterX">
          <g id="Group">
            <g id="Vector">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M 20 21.4662L 20.2652 21.7314L 37.8555 39.3218C 38.0593 39.5255 38.3076 39.625 38.5886 39.625C 38.8401 39.625 39.1213 39.5222 39.3218 39.3218C 39.7261 38.9174 39.7261 38.2599 39.3218 37.8555L 21.7314 20.2652L 21.4662 20L 21.7314 19.7348L 39.3218 2.14447C 39.7261 1.74015 39.7261 1.08257 39.3218 0.678246C 38.9174 0.273918 38.2599 0.273918 37.8555 0.678246L 20.2652 18.2686L 20 18.5338L 19.7348 18.2686L 2.14447 0.678246C 1.74015 0.273918 1.08257 0.273918 0.678246 0.678246C 0.273918 1.08257 0.273918 1.74015 0.678246 2.14447L 18.2686 19.7348L 18.5338 20L 18.2686 20.2652L 0.678246 37.8555C 0.273918 38.2599 0.273918 38.9174 0.678246 39.3218C 0.882017 39.5255 1.13032 39.625 1.41136 39.625C 1.6924 39.625 1.9407 39.5255 2.14447 39.3218L 19.7348 21.7314L 20 21.4662Z"
                fill={fill}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M 20 21.4662L 20.2652 21.7314L 37.8555 39.3218C 38.0593 39.5255 38.3076 39.625 38.5886 39.625C 38.8401 39.625 39.1213 39.5222 39.3218 39.3218C 39.7261 38.9174 39.7261 38.2599 39.3218 37.8555L 21.7314 20.2652L 21.4662 20L 21.7314 19.7348L 39.3218 2.14447C 39.7261 1.74015 39.7261 1.08257 39.3218 0.678246C 38.9174 0.273918 38.2599 0.273918 37.8555 0.678246L 20.2652 18.2686L 20 18.5338L 19.7348 18.2686L 2.14447 0.678246C 1.74015 0.273918 1.08257 0.273918 0.678246 0.678246C 0.273918 1.08257 0.273918 1.74015 0.678246 2.14447L 18.2686 19.7348L 18.5338 20L 18.2686 20.2652L 0.678246 37.8555C 0.273918 38.2599 0.273918 38.9174 0.678246 39.3218C 0.882017 39.5255 1.13032 39.625 1.41136 39.625C 1.6924 39.625 1.9407 39.5255 2.14447 39.3218L 19.7348 21.7314L 20 21.4662Z"
                strokeWidth="0.75"
                strokeMiterlimit="8"
                stroke={stroke}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/LetterX.js